import React from 'react';
import './style.css';

const SingleRow = () => {
  return (
    <div role="status" className="details-skeleton">
      <div />
    </div>
  )
}

export default SingleRow